import * as React from "react"
import { BrowserRouter as Router, Route, Switch } from "react-router-dom"
import Plan from "../screens/plans/Plans"
import Occupancy from "../screens/occupancy/OccupancyOverview"

class Plans extends React.Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route exact path="/plans" component={Plan} />
          <Route exact path="/occupancy" component={Occupancy} />
        </Switch>
      </Router>
    )
  }
}

export default Plans



// WEBPACK FOOTER //
// ./src/ui/layout/MainLayout.js